import PointLayer from "./PointLayer";

export default class PopulationLayer extends PointLayer {
    constructor(map, data, options = {}) {
        super(map, data, 'Population', options = {scale: 0.2});
        this.mapTooltip = null;
    }

    handlerNode(node, info) {
        node.s({
            'interactive': false,
            '2d.selectable': false,
            '3d.selectable': false,
        });
        const _inStartValue = parseInt(100 + 50 * Math.random());
        const _outStartValue = parseInt(100 + 50 * Math.random());
        
        node.a({
            inNumber:  _inStartValue,
            outNumber: _outStartValue
        });
        node.setDataBindings({
            "a": {
                "n_inNumber": {
                    "id": "$yy3d_rstj_n_inNumber"
                },
                "n_outNumber": {
                    "id": "$yy3d_rstj_n_outNumber"
                },
            }
        });
        if(!this.startInValue) {
            this.startInValue = [];
            this.startOutValue = [];
        }
        
        this.startInValue.push(_inStartValue);
        this.startOutValue.push(_outStartValue);
    }

    showLayer() {
        super.show();
    }

    hideLayer() {
        super.hide();
    }

    /**
     * 开启人员进出的数值变化动画
     */
    startLayerAnim() {
        if(!this.populationAnim) {
            let dsInCount = [],
                dsOutCount = [];
            
            const params = {
                delay: 3000,
                duration: 2000,
                easing: t => t,
                finishFunc: () => {
                    this.startInValue = [];
                    this.startOutValue = [];
                    dsInCount = [];
                    dsOutCount = [];

                    this.nodes.forEach(node => {
                        this.startInValue.push(node.a('inNumber'));
                        this.startOutValue.push(node.a('outNumber'));
                        dsInCount.push(parseInt(10 + 10 * Math.random()));
                        dsOutCount.push(parseInt(5 + 10 * Math.random()));
                    });
                    this.populationAnim = ht.Default.startAnim(params);
                },
                action: v => {
                    this.nodes.forEach((node,i) => {
                        const inStartValue = this.startInValue[i] || 0;
                        const outStartValue = this.startOutValue[i] || 0;
                        const inDs = dsInCount[i] || 0;
                        const outDs = dsOutCount[i] || 0;
                        node.a({
                            inNumber: inStartValue + parseInt(inDs * v),
                            outNumber: outStartValue + parseInt(outDs * v)
                        })
                    });
                }
            };
            this.populationAnim = ht.Default.startAnim(params);
        }
    }

    /**
     * 关闭租金数值变化的动画
     */
    stopLayerAnim() {
        if(this.populationAnim) {
            this.populationAnim.pause();
            this.populationAnim = null;
        }
    }
}

